import { render } from "./AppChip.vue?vue&type=template&id=580746c3&scoped=true"
import script from "./AppChip.vue?vue&type=script&lang=js"
export * from "./AppChip.vue?vue&type=script&lang=js"

import "./AppChip.vue?vue&type=style&index=0&id=580746c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580746c3"]])

export default __exports__